import * as Phaser from "phaser";
import { CommonVarsGlobalPlugin } from "$/game/plugins/CommonVarsGlobalPlugin.ts";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { BasicOverlay } from "$/game/prefabs/scenes/overlays/BasicOverlay.ts";

export class RoundedTextButton extends Phaser.GameObjects.Container {
  private buttonGfx: Phaser.GameObjects.Graphics;
  private buttonText: Phaser.GameObjects.Text;
  private defaultColor: number;
  private hoverColor: number;

  private global: CommonVarsGlobalPlugin;

  constructor(
    scene: BasicScene | BasicOverlay | Phaser.Scene,
    x: number,
    y: number,
    text: string,
    width: number = 200,
    height: number = 40,
    private radius: number,
    defaultColor: number,
    hoverColor: number,
    textStyle?: Phaser.Types.GameObjects.Text.TextStyle,
  ) {
    super(scene, x, y);

    this.global = scene.plugins.get("globalVars") as CommonVarsGlobalPlugin;

    this.defaultColor = defaultColor ||
      this.global.TUNER_TWA_CONFIG.palette.primary;
    this.hoverColor = hoverColor ||
      this.global.TUNER_TWA_CONFIG.palette.primary + 0x100000;

    // Создаем графику для кнопки
    this.buttonGfx = scene.add.graphics();
    this.buttonGfx.fillStyle(defaultColor, 1);
    this.buttonGfx.fillRoundedRect(
      -width / 2,
      -height / 2,
      width,
      height,
      this.radius,
    );

    this.buttonGfx.lineStyle(5, this.global.TUNER_TWA_CONFIG.palette.border, 1);
    this.buttonGfx.strokeRoundedRect(
      -width / 2,
      -height / 2,
      width,
      height,
      this.radius,
    );

    this.add(this.buttonGfx);

    // Создаем текст
    const defaultTextStyle: Phaser.Types.GameObjects.Text.TextStyle = {
      fontSize: "24px",
      color: "#ffffff",
      fontStyle: "bold",
      fontFamily: "Arial",
    };

    this.buttonText = scene.add.text(
      0,
      0,
      text,
      textStyle || defaultTextStyle,
    );
    this.buttonText.setOrigin(0.5);
    this.add(this.buttonText);

    // Добавляем интерактивную зону
    this.setSize(width, height);
    this.setInteractive({ useHandCursor: true });

    // Добавляем обработчики событий
    this.on("pointerover", () => this.onHover());
    this.on("pointerout", () => this.onOut());

    // Добавляем контейнер в сцену
    scene.add.existing(this);
  }

  private onHover(): void {
    // Останавливаем предыдущие твины
    this.scene.tweens.killTweensOf(this);

    this.buttonGfx.clear();
    this.buttonGfx.fillStyle(this.hoverColor, 1);
    this.buttonGfx.fillRoundedRect(
      -this.width / 2,
      -this.height / 2,
      this.width,
      this.height,
      this.radius,
    );

    this.buttonGfx.lineStyle(5, this.global.TUNER_TWA_CONFIG.palette.border, 1);
    this.buttonGfx.strokeRoundedRect(
      -this.width / 2,
      -this.height / 2,
      this.width,
      this.height,
      this.radius,
    );

    // Анимация увеличения и вращения
    this.scene.tweens.add({
      targets: this,
      scaleX: 1.08,
      scaleY: 1.08,
      angle: Math.random() * 5 - 2.5,
      duration: 200,
      ease: "Power2",
    });

    // this.scene.sound.play(resources.sounds.penClick, { volume: 0.1 });
  }

  private onOut(): void {
    // Останавливаем предыдущие твины
    this.scene.tweens.killTweensOf(this);

    this.buttonGfx.clear();
    this.buttonGfx.fillStyle(this.defaultColor, 1);
    this.buttonGfx.fillRoundedRect(
      -this.width / 2,
      -this.height / 2,
      this.width,
      this.height,
      this.radius,
    );
    this.buttonGfx.lineStyle(5, this.global.TUNER_TWA_CONFIG.palette.border, 1);
    this.buttonGfx.strokeRoundedRect(
      -this.width / 2,
      -this.height / 2,
      this.width,
      this.height,
      this.radius,
    );

    // Анимация возврата к исходному состоянию
    this.scene.tweens.add({
      targets: this,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      duration: 200,
      ease: "Power2",
    });
  }

  public setText(text: string): void {
    this.buttonText.setText(text);
  }

  public getText(): string {
    return this.buttonText.text;
  }
}
